import { createVuetify } from "vuetify";
import { de, en } from "vuetify/locale";
// import this after install `@mdi/font` package
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

export default defineNuxtPlugin((app) => {
  const i18n = app.$i18n;
  const vuetify = createVuetify({
    // Vuetify's own texts (data table footer, date picker, ...) follow the language of the portal.
    locale: {
      locale: i18n.locale.value,
      fallback: "en",
      messages: {
        de: {
          ...de,
          dataFooter: { ...de.dataFooter, itemsPerPageText: "Einträge pro Seite:" },
        },
        en,
      },
    },
    theme: {
      defaultTheme: "light",
      themes: {
        light: {
          colors: {
            primary: "#1FC795",
            secondary: "#FFFFFF",
          },
        },
        // TODO: add dark mode
      },
    },
  });
  app.vueApp.use(vuetify);
  // Follows every change of the portal language, not only the ones made through setLocale.
  watch(i18n.locale, (locale) => {
    vuetify.locale.current.value = locale;
  });
});
